import Header from "./Header";
import Footer from "./Footer";
import {ID_TOKEN, LEFT_SIDE_BAR} from "../../conf";
import React, {useEffect} from "react";
import {decodeIdToken} from "../../services/session/apiSession";
import {useSessionStore} from "../../services/storage/SessionStorage";
import {getSessionByCookie} from "../../utils/decode/getSessionByCookie";

interface Props {
    children?: React.ReactNode;
}

const Layout = ({
                    children,
                }: Props) => {
    const setUser = useSessionStore(data => data.setUser)

    useEffect(() => {
        const session = getSessionByCookie(ID_TOKEN);
        const tokenFromCookie = decodeIdToken(session?.access_token);
        if (session?.access_token && tokenFromCookie) {
            setUser(tokenFromCookie);
        }
    }, [setUser]);

    return (
        <div className={"h-screen flex flex-col"}>
            <Header/>
            <div className={`${LEFT_SIDE_BAR ? 'custom-container-left-bar' : 'custom-container-all-window'} mt-[100px] px-2 sm:px-0 sm:mt-[87px]`}>
                <div className={`${LEFT_SIDE_BAR ? 'right-column' : 'center-column'} h-screen sm:h-full`}>
                    <div className={'pb-3 body'}>
                        <main>{children}</main>
                    </div>
                    <Footer/>
                </div>
            </div>
        </div>
    );
}

export default Layout;
